export const version = "1.7.18-daily-20260908-0";
export const channel = "daily";
export const gitcommit = "8d5c31920";
